import { useState, useEffect } from 'react';
import HeaderLayout from '../../components/layout/header';
import { Tag, Divider, List, Skeleton, Button } from 'antd';

import { useNavigate } from 'react-router-dom';
const count = 5;

const fakeUrl = (count) => {
    return `https://randomuser.me/api/?results=${count}&inc=name,gender,email,nat,picture&noinfo`;
};

export default function NotificationPage() {
    const navigate = useNavigate();
    const [initLoading, setInitLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [list, setList] = useState([]);
    const [notiSelect, setNotiSelect] = useState(1);
    useEffect(() => {
        fetch(fakeUrl(15))
            .then((res) => res.json())
            .then((res) => {
                setInitLoading(false);
                setData(res.results);
                setList(res.results);
            });
    }, []);
    const onLoadMore = () => {
        setLoading(true);
        setList(
            data.concat(
                [...new Array(count)].map(() => ({
                    loading: true,
                    name: {},
                    picture: {},
                }))
            )
        );
        console.log(list);
        fetch(fakeUrl(5))
            .then((res) => res.json())
            .then((res) => {
                const newData = data.concat(res.results);
                console.log('newData', res.results);

                setData(newData);
                setList(newData);
                setLoading(false); // Resetting window's offsetTop so as to display react-virtualized demo underfloor.
                // In real scene, you can using public method of react-virtualized:
                // https://stackoverflow.com/questions/46700726/how-to-use-public-method-updateposition-of-react-virtualized

                window.dispatchEvent(new Event('resize'));
            });
    };
    const loadMore =
        !initLoading && !loading ? (
            <div className="text-center py-3">
                <Button className="" onClick={onLoadMore}>
                    loading more
                </Button>
            </div>
        ) : null;
    return (
        <div className="bg-gray-body min-h-screen pb-24">
            <HeaderLayout />
            <div className="w-full">
                <div className="container mx-auto px-5">
                    <div className="mx-auto w-full max-w-lg rounded-2xl shadow-lg bg-white">
                        <div className="px-4 py-2">
                            <div className="flex justify-between">
                                <div className="font-semibold py-3">
                                    Notification
                                </div>
                                <button
                                    type="button"
                                    className="font-semibold py-3 cursor-pointer"
                                    style={{ color: '#7B67FB' }}
                                    onClick={() => {
                                        navigate(-1);
                                    }}
                                >
                                    <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M12 4L4 12"
                                            stroke="#171717"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M4 4L12 12"
                                            stroke="#171717"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <Divider style={{ margin: '0px' }}></Divider>
                        <div className="p-3">
                            <Tag
                                className={`cursor-pointer custom-notification-tab ${
                                    notiSelect === 1 ? 'select' : ''
                                }`}
                                onClick={() => setNotiSelect(1)}
                            >
                                All
                            </Tag>
                            <Tag
                                className={`cursor-pointer custom-notification-tab ${
                                    notiSelect === 2 ? 'select' : ''
                                }`}
                                onClick={() => setNotiSelect(2)}
                            >
                                Unread
                            </Tag>
                        </div>
                        <Divider style={{ margin: '0px' }}></Divider>

                        <List
                            className="demo-loadmore-list"
                            loading={initLoading}
                            itemLayout="horizontal"
                            loadMore={loadMore}
                            dataSource={list}
                            renderItem={(item) => (
                                <List.Item className="block p-0">
                                    <Skeleton
                                        avatar
                                        title={true}
                                        loading={item.loading}
                                        active
                                    >
                                        <div
                                            className="flex p-5 cursor-pointer hover:opacity-75 duration-150"
                                            style={{
                                                backgroundColor: false
                                                    ? ''
                                                    : '#F5F6FF',
                                            }}
                                        >
                                            <div className="w-5 flex-initial">
                                                {true ? (
                                                    <svg
                                                        width="8"
                                                        height="24"
                                                        viewBox="0 0 8 24"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <circle
                                                            cx="4"
                                                            cy="11"
                                                            r="4"
                                                            fill="#7B67FB"
                                                        />
                                                    </svg>
                                                ) : (
                                                    <svg
                                                        width="8"
                                                        height="8"
                                                        viewBox="0 0 8 8"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                    >
                                                        <circle
                                                            cx="4"
                                                            cy="4"
                                                            r="4"
                                                            fill="#65707A"
                                                        />
                                                    </svg>
                                                )}
                                            </div>
                                            <div className="w-96 flex-initial">
                                                <div className="notification-title">
                                                    <span className="flex">
                                                        เจ้าของข้อมูลชื่อ
                                                        แพรธันยา ปวราธิดา
                                                    </span>
                                                    <span className="flex">
                                                        ขอใช้สิทธิในการเพิกถอนความยินยอม
                                                        โปรดตรวจสอบรายการที่เมนู
                                                        KYC
                                                    </span>
                                                </div>
                                                <div className="">
                                                    <span className="block">
                                                        โปรดดำเนินการให้แล้วเสร็จภายใน
                                                        30 วัน
                                                    </span>
                                                    <span className="block">
                                                        15/07/2021 13:20
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </Skeleton>
                                </List.Item>
                            )}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
